module.exports = __webpack_public_path__ + "static/img/pic-cnt-1.ccc2c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/en/pic-cnt-1.png
// module id = W0O6
// module chunks = 0